export default class Transaction {
  /**
   * Create new transactions
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)

    // Map Linked Transactions to Transactions
    if (typeof this.linkedTransactions !== 'undefined') {
      this.linkedTransactions = this.linkedTransactions.map(transaction => new Transaction(transaction))
    }
  }

  /**
   * @return {Date}
   */
  get date () {
    return this._date
  }

  /**
   * @param {string} value
   */
  set date (value) {
    this._date = new Date(value)
  }

  /**
   * @return {string}
   */
  get transactionReference () {
    return this.channel === 'Gateway' ? this.paymentJobReference : this.transactionId
  }

  /**
   * @return {Array}
   */
  get paymentMethods () {
    if (this.walletType) {
      return this.walletType.split(',').map(paymentMethod => paymentMethod === 'Other' ? 'Wallet' : paymentMethod)
    }
    if (this.scheme) {
      return this.scheme
        .split(',')
        .map(scheme => {
          if (scheme === 'AM') {
            scheme = 'AMX'
          }
          return ['AMX', 'VI', 'MC'].includes(scheme) ? scheme : 'Card'
        })
    }
    return this._paymentMethods
  }

  get walletType () {
    return this.transactionSpecificData ? this.transactionSpecificData.ewalletType : this.ewalletType
  }

  get scheme () {
    return this.transactionSpecificData ? this.transactionSpecificData.cardScheme : this.cardScheme
  }

  /**
   * @param {string} value
   */
  set paymentMethods (value) {
    this._paymentMethods = value.split(',')
  }
}
